import { DateTime } from "luxon";
import React from "react";

import { LanguageContext } from "../../../i18n/strings";
import "./Timestamp.scss";

export interface TimestampProps {
  time: number;
}

export class Timestamp extends React.Component<TimestampProps> {
  static contextType = LanguageContext;
  declare context: React.ContextType<typeof LanguageContext>;

  constructor(props: TimestampProps) {
    super(props);
  }

  render() {
    const timeAgo = DateTime.fromMillis(this.props.time).toRelative({ locale: this.context });
    return <div className="scc-Timestamp">{timeAgo}</div>;
  }
}
